/* F·11 — overlay sequencing controller.
 *
 * Coordinates the cookie consent banner and the Klaviyo newsletter
 * popup so they never render on the same frame. Order of precedence:
 *
 *   1. Consent always wins on first paint.
 *   2. Newsletter only after consent is resolved AND
 *      (scrollY > 60% of doc height OR sessionCount >= 2).
 *   3. Dismissal persists in localStorage for 30 days per overlay.
 *   4. prefers-reduced-motion suppresses any "animate-in" intent.
 *
 * Used by:
 *   - assets/lc-cookie-consent.js (dispatches `lc:consent` on decide)
 *   - assets/lc-klaviyo-popup.js (calls onConsentResolved + canShowNewsletter)
 */
(function () {
  var TTL_DAYS = 30;
  var TTL_MS = TTL_DAYS * 86400000;
  var SCROLL_THRESHOLD = 0.6;
  var SESSION_COUNT_KEY = 'lc_session_count';
  var DISMISSED_PREFIX = 'lc_dismissed_';
  var CONSENT_KEY = 'lc_cookie_consent';

  // Bump session count on every page load (sessionStorage scoped to tab).
  try {
    var c = parseInt(sessionStorage.getItem(SESSION_COUNT_KEY) || '0', 10);
    sessionStorage.setItem(SESSION_COUNT_KEY, String(c + 1));
  } catch (_e) {}

  function lsGet(k) {
    try { return localStorage.getItem(k); } catch (_e) { return null; }
  }
  function lsSet(k, v) {
    try { localStorage.setItem(k, v); } catch (_e) {}
  }

  function consentResolved() {
    return !!lsGet(CONSENT_KEY);
  }

  function isDismissed(name) {
    var ts = lsGet(DISMISSED_PREFIX + name);
    if (!ts) return false;
    return Date.now() - Number(ts) < TTL_MS;
  }

  function markDismissed(name) {
    lsSet(DISMISSED_PREFIX + name, String(Date.now()));
  }

  function sessionCount() {
    try { return parseInt(sessionStorage.getItem(SESSION_COUNT_KEY) || '0', 10); }
    catch (_e) { return 1; }
  }

  function scrollPct() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (max <= 0) return 1;
    return window.scrollY / max;
  }

  function reducedMotion() {
    return !!(window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  // Newsletter gate: consent in + (scroll>60% OR session>=2) + not dismissed.
  function canShowNewsletter() {
    if (!consentResolved()) return false;
    if (isDismissed('newsletter')) return false;
    if (sessionCount() >= 2) return true;
    return scrollPct() >= SCROLL_THRESHOLD;
  }

  // Run callback once consent is resolved. If already resolved, fire on next
  // tick so callers can subscribe synchronously. Otherwise listen for the
  // `lc:consent` event dispatched by lc-cookie-consent.js.
  var pending = [];
  function flush() {
    var q = pending.slice();
    pending = [];
    q.forEach(function (fn) { try { fn(); } catch (_e) {} });
  }
  document.addEventListener('lc:consent', flush);

  function onConsentResolved(fn) {
    if (consentResolved()) {
      // setTimeout 0 so subscriber gets a clean async boundary.
      setTimeout(fn, 0);
    } else {
      pending.push(fn);
    }
  }

  window.LCOverlayController = {
    consentResolved: consentResolved,
    onConsentResolved: onConsentResolved,
    canShowNewsletter: canShowNewsletter,
    isDismissed: isDismissed,
    markDismissed: markDismissed,
    sessionCount: sessionCount,
    scrollPct: scrollPct,
    reducedMotion: reducedMotion,
  };
})();
